import React, { useState, useEffect } from 'react';

import { AsyncSelect } from '../../../components/Input.components';
import { Boxed } from '../../../components/Boxed.components';
import { Text } from '../../../components/Text.components';
import { Button } from '../../../components/Button.components';
import { ModalComponent } from '../../../components/Modal.components';
import { Avatar } from '../../../components/Avatar.components';

import { components } from 'react-select';

import { PageTitle } from '../../../components/style';
import { Badge } from 'react-bootstrap';

let timer = null;

export const SubmitModal = (props) => {
  // State props
  const { payload, isLoadingSubmit, usersList, isLoadingUsers } = props;

  // Dispatch props
  const { form, submitRequest, closeModal, fetchUsers } = props;
  const { getFieldProps,  validateFields } = form;

  const pageData = { 
    limit: 50,
    page: 1,
}
  useEffect(() => {
    fetchUsers(pageData);
  }, []);


  const handleUserSearch = (e) => { 
    const searchKey = e?.target?.value;

    if (searchKey) {
        clearTimeout(timer);
        timer = setTimeout(() => { 
            fetchUsers({search: searchKey, ...pageData});
        }, 3000)
    }
  }

  const onSubmit = () => {
    validateFields((error, values) => {
      if (!error) {
        const payloadData = {
            ...payload,
          additionalReviewers: values?.additionalReviewers?.map(item => ({ _id: item.value})) ?? [],
        };
        submitRequest(payloadData);
      }
    });
  };

  const CustomUserOption = (props) => {
    const { data } = props;
    return (
      <components.Option {...props}>
        <Avatar size={'24px'} src={data?.extra?.profilePictureUrl ?? ''} name={data?.label} />
      </components.Option>
    );
  };

  const CustomMultiValueLabel = (props) => {
    const { data } = props;
    return (
      <components.MultiValueLabel {...props}>
        <Avatar size={'24px'} src={data?.extra?.profilePictureUrl ?? ''} name={data?.label} />
      </components.MultiValueLabel>
    );
  }

  return (
    <>
      <ModalComponent
        show={payload}
        onHide={closeModal}
        centered
        title={<PageTitle margin="5px 0">Submit Request</PageTitle>}
        footer={
          <Boxed display="flex" width="100%">
            <Button clear onClick={closeModal}>
              Cancel
            </Button>
            <Button
              margin="0 0 0 auto"
              progress={isLoadingSubmit}
              disabled={isLoadingSubmit}
              onClick={onSubmit}
            >
              Submit Request
            </Button>
          </Boxed>
        }
      >
        <Boxed pad="20px 0" minHeight='250px'>
          <AsyncSelect
            label="Additional Reviewers"
            isMulti
            placeholder="Select additional Reviewers"
            options={usersList?.map((item) => ({
              label: `${item?.lastName} ${item?.firstName}`,
              value: item._id,
              extra: item
            }))}
            components={{ Option: CustomUserOption, MultiValueLabel: CustomMultiValueLabel }}
            {...getFieldProps('additionalReviewers', {
              initialValue: '',
              rules: []
            })}
            loading={isLoadingUsers}
            height="auto"
          />
        </Boxed>
      </ModalComponent>
    </>
  );
};
